"use client";

import {
  useTheme,
  useMediaQuery,
  Typography,
  Link,
  Grid,
  Collapse,
} from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";
import Image from "next/image";
import { useState, useEffect } from "react";
import { PodcastsItem } from "@/types/podcasts";
import React from "react";
import { useText } from "@/context/TextContext";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { unitToVw } from "@/utils/unitToVw";


type Props = {
  Podcasts: PodcastsItem[];
};

function SpotifyIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 22 22"
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.41667 13.75C6.41667 13.75 10.5417 12.8333 14.6667 14.6667M5.95833 11C5.95833 11 11.4583 9.625 16.0417 12.375M5.5 8.25C8.25 7.79167 12.8333 7.33333 17.4167 10.0833" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.0007 20.1667C5.9379 20.1667 1.83398 16.0628 1.83398 11C1.83398 5.93725 5.9379 1.83333 11.0007 1.83333C16.0634 1.83333 20.1673 5.93725 20.1673 11C20.1673 16.0628 16.0634 20.1667 11.0007 20.1667Z" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
}

function BtvIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7350_693)">
          <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="0.9" />
          <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="0.9" />
          <circle cx="11" cy="11" r="3" fill="currentColor" />
        </g>
        <defs>
          <clipPath id="clip0_7350_693">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

function AmazonMusicIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_7350_697)">
          <path fillRule="evenodd" clipRule="evenodd" d="M15.6433 14.2671C14.2231 14.8699 12.6534 15.1712 11.0838 15.1712C8.99087 15.1712 6.97272 14.6438 5.17882 13.589C5.02932 13.5137 4.95458 13.6644 5.02932 13.7397C6.67374 15.2466 8.76663 16 10.9343 16C12.6534 16 14.3726 15.4726 15.7928 14.4932C16.0918 14.4178 15.8675 14.1164 15.6433 14.2671ZM16.9887 13.5137C16.316 13.2123 15.4938 13.2877 14.8958 13.7397C14.7463 13.8151 14.8211 13.9658 14.8958 13.8904C15.3443 13.8151 16.2413 13.7397 16.3907 13.9658C16.5402 14.1918 16.2413 15.0959 16.017 15.4726C15.9423 15.6233 16.0918 15.6233 16.1665 15.5479C16.7645 15.0205 17.0635 14.2671 16.9887 13.5137ZM10.2616 12.5342C11.0838 12.6096 11.906 12.2329 12.4292 11.5548C12.6534 11.8562 12.8777 12.1575 13.1767 12.4589C13.2514 12.5342 13.4009 12.5342 13.4756 12.4589C13.6999 12.2329 14.2231 11.7808 14.4473 11.5548C14.5221 11.4795 14.5221 11.3288 14.4473 11.1781C14.1484 10.8767 13.9989 10.4247 13.9241 9.9726V7.93836C13.9241 7.10959 13.9989 6.28082 13.3261 5.67808C12.8029 5.22603 12.0555 5 11.3827 5C10.1868 5.07534 8.76663 5.5274 8.54239 7.03425C8.54239 7.18493 8.61714 7.26027 8.76663 7.26027L10.0373 7.41096C10.1868 7.41096 10.2616 7.26027 10.2616 7.18493C10.3363 6.65753 10.7848 6.35616 11.308 6.43151C11.607 6.43151 11.8312 6.58219 12.0555 6.80822C12.205 7.10959 12.2797 7.41096 12.205 7.78767V7.93836C11.3827 7.93836 10.5605 8.08904 9.73833 8.39041C8.84138 8.69178 8.24341 9.52055 8.31816 10.5V10.8014C8.31816 11.7808 9.21511 12.6096 10.2616 12.5342ZM12.1302 8.91781V9.21918C12.205 9.67123 12.1302 10.1986 11.906 10.5753C11.7565 10.9521 11.3827 11.1781 11.009 11.1781C10.4858 11.1781 10.1868 10.8014 10.1868 10.1986C10.1868 9.14384 11.1585 8.91781 12.1302 8.91781Z" fill="currentColor" />
          <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="0.9" />
        </g>
        <defs>
          <clipPath id="clip0_7350_697">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

function IvooxIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33594 1.7832C15.244 -0.194347 21.7444 5.79303 20.4287 12.916C19.7429 16.6303 16.8246 19.6664 13.1953 20.5078V8.39453C13.1953 8.20385 13.104 8.02904 13.0322 7.91504C12.9507 7.78557 12.8439 7.65731 12.7324 7.54492C12.621 7.43266 12.4938 7.32551 12.3652 7.24316C12.2524 7.17094 12.0776 7.07721 11.8857 7.07715H5.66797V11.333H8.84082V20.5127C5.56091 19.7818 2.81233 17.2125 1.82715 13.9639C0.250404 8.76184 3.17944 3.2595 8.33594 1.7832ZM12.2803 2.68359C11.804 2.33764 11.1796 2.17148 10.4463 2.27148C10.0472 2.32596 9.66739 2.53862 9.36719 2.79785C9.06582 3.0581 8.80737 3.39776 8.67578 3.75684C7.9643 5.70027 9.80377 7.57248 11.749 6.84961H11.75C13.0129 6.37968 13.4342 5.11135 13.1807 4.05762C13.0528 3.52649 12.7516 3.02596 12.2803 2.68359Z" stroke="currentColor" strokeWidth="0.8" />
      </svg>
    </SvgIcon>
  );
}

export default function PodcastSection({ Podcasts }: Props) {
  const [expandedBlocks, setExpandedBlocks] = useState<{
    [key: number]: boolean;
  }>({});

  useEffect(() => {
    // Detectar hash en la URL al montar o cuando cambia
    const hash = window.location.hash.slice(1); // Remover el #
    if (hash) {
      // Buscar el episodio que coincida con la fecha
      const index = Podcasts.findIndex(
        (episode) => episode.Fecha === hash
      );
      if (index !== -1) {
        setExpandedBlocks((prev) => ({
          ...prev,
          [index]: true,
        }));
        // Hacer scroll después de un pequeño delay para asegurar que el accordion se ha expandido
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const isMobileView = window.innerWidth < 900; // breakpoint md
            const offsetPosition = elementPosition - (isMobileView ? unitToVw(145, MOBILE_BASE) : unitToVw(420));
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }
        }, 300);
      }
    }
  }, [Podcasts]);

  const handleToggle = (index: number) => {
    setExpandedBlocks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid container spacing={{ xs: pxToVw(20, MOBILE_BASE), md: pxToVw(8) }}>
      <Grid
        container
        size={{ xs: 9, md: 3 }}
        offset={{ xs: 3, md: 0 }}
        borderTop={{ xs: "none", md: "1px solid #472600" }}
        pt={pxToVw(10)}
        mb={{ xs: pxToVw(50, MOBILE_BASE), md: pxToVw(0) }}
      >
        <Image
          alt="Podcast"
          src={useText("podcast.image")}
          width={226}
          height={226}
          style={{
            width: isMobile ? pxToVw(271, MOBILE_BASE) : pxToVw(226),
            height: isMobile ? "100%" : pxToVw(226),
            objectFit: "contain",
          }}
        />
      </Grid>
      <Grid
        size={{ xs: 12, md: 9 }}
        columns={{ xs: 12, md: 9 }}
        container
        spacing={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(30) }}
      >
        {Podcasts.map((episode, index) => {
          const isExpanded = expandedBlocks[index] || false;

          return (
            <React.Fragment key={index}>
              {!isMobile && (
                <Grid
                  id={episode.Fecha}
                  size={{ xs: 12, md: 9 }}
                  columns={{ xs: 12, md: 9 }}
                  paddingTop={{ xs: pxToVw(5, MOBILE_BASE), md: pxToVw(10) }}
                  borderTop={"1px solid #472600"}
                  container
                  spacing={{ xs: pxToVw(12, MOBILE_BASE), md: pxToVw(8) }}
                  onClick={() => handleToggle(index)}
                >
                  <Grid size={{ xs: 12, md: 1 }} container>
                    <Typography
                      variant="body5"
                      fontSize={{ xs: pxToVw(16, MOBILE_BASE), md: pxToVw(16) }}
                      lineHeight={{
                        xs: pxToVw(17.6, MOBILE_BASE),
                        md: pxToVw(18.4),
                      }}
                      color="marron"
                      sx={{
                        cursor: "pointer",
                        ":hover": {
                          color: "#9B8D82",
                        },
                      }}
                    >
                      {episode.Fecha}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 12, md: 2 }} container>
                    <Typography
                      variant="body5"
                      component="h2"
                      fontSize={{ xs: pxToVw(16, MOBILE_BASE), md: pxToVw(16) }}
                      lineHeight={{
                        xs: pxToVw(17.6, MOBILE_BASE),
                        md: pxToVw(18.4),
                      }}
                      color="marron"
                      sx={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                        ":hover": {
                          color: "#9B8D82",
                        },
                      }}
                    >
                      {episode.Autor}
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }} container>
                    <Typography
                      variant="body5"
                      fontSize={{ xs: pxToVw(16, MOBILE_BASE), md: pxToVw(16) }}
                      lineHeight={{
                        xs: pxToVw(17.6, MOBILE_BASE),
                        md: pxToVw(18.4),
                      }}
                      color="marron"
                      sx={{
                        cursor: "pointer",
                        ":hover": {
                          color: "#9B8D82",
                        },
                      }}
                    >
                      {episode.Titulo}
                    </Typography>
                    {episode.Descripcion && (
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <Typography
                          display="flex"
                          flexDirection="column"
                          variant="body5"
                          fontSize={{
                            xs: pxToVw(16, MOBILE_BASE),
                            md: pxToVw(16),
                          }}
                          lineHeight={{
                            xs: pxToVw(17.6, MOBILE_BASE),
                            md: pxToVw(18.4),
                          }}
                          color="marron"
                          mt={{ xs: pxToVw(10, MOBILE_BASE), md: pxToVw(16) }}
                        >
                          {episode.Descripcion}
                        </Typography>
                      </Collapse>
                    )}
                  </Grid>
                  <Grid
                    size={{ xs: 12, md: 1 }}
                    offset={{ md: 1 }}
                    container
                    gap={pxToVw(6)}
                  >
                    {[
                      {
                        key: "spotify",
                        href: episode.Enlace,
                        alt: "Play en Spotify",
                        title: "Play en Spotify",
                        Icon: SpotifyIcon,
                      },
                      {
                        key: "btv",
                        href: episode.LinkBTV,
                        alt: "Play en BTV",
                        title: "Play en BTV",
                        Icon: BtvIcon,
                      },
                      {
                        key: "amazon-music",
                        href: episode.LinkAmazonMusic,
                        alt: "Play en Amazon Music",
                        title: "Play en Amazon Music",
                        Icon: AmazonMusicIcon,
                      },
                      {
                        key: "ivoox",
                        href: episode.LinkIvoox,
                        alt: "Play en Ivoox",
                        title: "Play en Ivoox",
                        Icon: IvooxIcon,
                      },
                    ]
                      .filter((item) => !!item.href)
                      .map(({ key, href, title, Icon }) => (
                        <Link
                          key={key}
                          href={href}
                          underline="always"
                          color="warmaa"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                          className={"podcast-link " + key}
                          title={title}
                          sx={{
                            cursor: "pointer",
                            color: "#858276", // color base de las líneas
                            "&:hover": {
                              color: "#472600", // aquí cambian las líneas a marrón
                            },
                            "& svg": {
                              width: isMobile ? pxToVw(22, MOBILE_BASE) : pxToVw(22),
                              height: isMobile ? pxToVw(22, MOBILE_BASE) : pxToVw(22),
                              display: "block",
                            },
                          }}
                        >
                          <Icon aria-label={title} />
                        </Link>
                      ))}
                  </Grid>
                  <Grid
                    size={{ xs: 1, md: 1 }}
                    container
                    justifyContent="flex-end"
                  >
                    <Typography
                      variant="label1"
                      color="marron"
                      sx={{
                        cursor: "pointer",
                        ":hover": { color: "#9B8D82" },
                      }}
                    >
                      {isExpanded ? "↑" : "↓"}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {isMobile && (
                <Grid
                  id={episode.Fecha}
                  size={{ xs: 12, md: 9 }}
                  columns={{ xs: 12, md: 9 }}
                  container
                  spacing={{ xs: pxToVw(12, MOBILE_BASE), md: pxToVw(8) }}
                  onClick={() => handleToggle(index)}
                >
                  <Grid
                    size={{ xs: 3, md: 1 }}
                    container
                    borderTop={"1px solid #472600"}
                    paddingTop={{ xs: pxToVw(6, MOBILE_BASE), md: pxToVw(10) }}
                  >
                    <Typography
                      variant="body5"
                      fontSize={{ xs: pxToVw(16, MOBILE_BASE), md: pxToVw(16) }}
                      lineHeight={{
                        xs: pxToVw(17.6, MOBILE_BASE),
                        md: pxToVw(18.4),
                      }}
                      color="marron"
                    >
                      {episode.Fecha}
                    </Typography>
                  </Grid>
                  <Grid
                    size={{ xs: 9, md: 2 }}
                    container
                    borderTop={"1px solid #472600"}
                    paddingTop={{ xs: pxToVw(6, MOBILE_BASE), md: pxToVw(10) }}
                  >
                    <Grid
                      size={{ xs: 11, md: 2 }}
                      container
                      direction="column"
                      gap={0}
                    >
                      <Typography
                        variant="body5"
                        component="h3"
                        fontSize={{
                          xs: pxToVw(16, MOBILE_BASE),
                          md: pxToVw(16),
                        }}
                        lineHeight={{
                          xs: pxToVw(17.6, MOBILE_BASE),
                          md: pxToVw(18.4),
                        }}
                        color="marron"
                        sx={{ textTransform: "uppercase" }}
                      >
                        {episode.Autor}
                      </Typography>
                      <Typography
                        variant="body5"
                        fontSize={{
                          xs: pxToVw(16, MOBILE_BASE),
                          md: pxToVw(16),
                        }}
                        lineHeight={{
                          xs: pxToVw(17.6, MOBILE_BASE),
                          md: pxToVw(18.4),
                        }}
                        color="marron"
                        mt={pxToVw(6, MOBILE_BASE)}
                      >
                        {episode.Titulo}
                      </Typography>
                      {episode.Descripcion && (
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Typography
                            variant="body5"
                            fontSize={{
                              xs: pxToVw(16, MOBILE_BASE),
                              md: pxToVw(16),
                            }}
                            lineHeight={{
                              xs: pxToVw(17.6, MOBILE_BASE),
                              md: pxToVw(18.4),
                            }}
                            color="marron"
                            mt={pxToVw(12, MOBILE_BASE)}
                          >
                            {episode.Descripcion}
                          </Typography>
                        </Collapse>
                      )}
                      <Grid
                        size={{ xs: 12, md: 1 }}
                        offset={{ md: 1 }}
                        container
                        gap={pxToVw(6, MOBILE_BASE)}
                        mt={pxToVw(6, MOBILE_BASE)}
                      >
                        {[
                          {
                            key: "spotify",
                            href: episode.Enlace,
                            alt: "Play en Spotify",
                            title: "Play en Spotify",
                            Icon: SpotifyIcon,
                          },
                          {
                            key: "btv",
                            href: episode.LinkBTV,
                            alt: "Play en BTV",
                            title: "Play en BTV",
                            Icon: BtvIcon,
                          },
                          {
                            key: "amazon-music",
                            href: episode.LinkAmazonMusic,
                            alt: "Play en Amazon Music",
                            title: "Play en Amazon Music",
                            Icon: AmazonMusicIcon,
                          },
                          {
                            key: "ivoox",
                            href: episode.LinkIvoox,
                            alt: "Play en Ivoox",
                            title: "Play en Ivoox",
                            Icon: IvooxIcon,
                          },
                        ]
                          .filter((item) => !!item.href)
                          .map(({ key, href, title, Icon }) => (
                            <Link
                              key={key}
                              href={href}
                              underline="always"
                              color="warmaa"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className={"podcast-link " + key}
                              sx={{
                                cursor: "pointer",
                                color: "#858276", // color base de las líneas
                                "&:hover": {
                                  color: "#472600", // aquí cambian las líneas a marrón
                                },
                                "& svg": {
                                  width: isMobile ? pxToVw(22, MOBILE_BASE) : pxToVw(22),
                                  height: isMobile ? pxToVw(22, MOBILE_BASE) : pxToVw(22),
                                  display: "block",
                                },
                              }}
                            >
                              <Icon aria-label={title} />
                            </Link>
                          ))}

                      </Grid>
                    </Grid>
                    <Grid
                      size={{ xs: 1, md: 1 }}
                      container
                      justifyContent="flex-end"
                    >
                      <Typography
                        fontSize={{
                          xs: pxToVw(18, MOBILE_BASE),
                          md: pxToVw(20),
                        }}
                        color="marron"
                        sx={{
                          cursor: "pointer",
                        }}
                      >
                        {isExpanded ? "↑" : "↓"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          );
        })}
      </Grid>
    </Grid>
  );
}
